import axios from 'axios'
import {
  Message,
} from 'element-ui'

// 获取URL中token
function getQueryString(name) {
  var reg = new RegExp(name + "=([^&]*)(&|$)");
  var r = window.location.href.match(reg);
  let res = null;
  if (r != null) {
    res = r[1].trim().split(",")[0];
    // if (r[1].trim().split(",")[1]) {
    //   let language = r[1].trim().split(",")[1];
    //   i18n.locale = language;
    //   localStorage.setItem("locale", language);
    // }
  }
  return res;
}




const service = axios.create({
  timeout: 60000, // request timeout
  headers: {
    // accessToken先写死后期要改
    'Content-Type': 'application/json; charset=utf-8',
  },
})

// request interceptor  
service.interceptors.request.use(
  config => {
    // 获取token，优先级：URL参数 > CCDK
    let binding = getQueryString("accessToken") || getQueryString("binding");
    
    // 如果URL中没有token，从CCDK获取
    if (!binding && window.$CCDK && window.$CCDK.CCToken) {
      try {
        binding = window.$CCDK.CCToken.getToken('binding', 'partnerToken');
      } catch (e) {
        console.warn('从CCDK获取token失败:', e);
      }
    }
    
    
    // 同步token到CCDK
    if (binding) {
      
      // 更新CCDK
      if (window.$CCDK && window.$CCDK.CCToken) {
        try {
          const currentCCDKToken = window.$CCDK.CCToken.getToken('binding', 'partnerToken');
          if (currentCCDKToken !== binding) {
            window.$CCDK.CCToken.setToken(binding, 'partnerToken');
          }
        } catch (e) {
          console.warn('更新CCDK token失败:', e);
        }
      }
    }
    // 这些接口不需要token
    const noTokenAPIs = ["api/product/"];
    const needToken = !noTokenAPIs.some(api => config.url.indexOf(api) !== -1);
    
    // 如果需要token且有binding，但要检查是否已经手动设置了accessToken
    if (needToken && binding && !config.headers.accessToken) {
      config.headers.accessToken = binding
    }


    return config
  },
  error => {
    // Do something with request error
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const code = response.data.code || 200
    if (code !== 200) {
      return Promise.reject(null == response.data.msg ? "未知异常" : response.data.msg)
    } else {
      if (response.data.returnCode === '10002') {
        return;
      } else {
        return response.data
      }
    }
  },
  async error => {

    let errorMessage = ''; // 定义要提示的错误信息
    if (error.message.indexOf('cancelToken') !== -1) {
      return;
    } else if (error.message.indexOf('400') !== -1) {
      if (error && error.response) {
        // 由后端捕获到异常然后抛出来，返回状态码400
        errorMessage = error.response.data.returnInfo || error.response.data.customInfo;
      } else {
        errorMessage = '错误请求，如语法错误，错误码400'
      }
    } else if (error.message.indexOf('413') !== -1) {
      errorMessage = '请求参数过长，请检查输入内容，错误码413'
    } else if (error.message.indexOf('404') !== -1) {
      errorMessage = '请求资源已丢失，请联系系统管理员'
    } else if (error.message.indexOf('500') !== -1) {
      if (error && error.response) {
        // 由后端捕获到异常然后抛出来，返回状态码500
        errorMessage = error.response.data.returnInfo;
        if (error.response.data.customInfo.indexOf('accessToken') !== -1) {
          console.log('token失效')
          return
        }
      } else {
        errorMessage = '获取资源端资源失败，请联系系统管理员，错误码500'
      }
    } else {
      errorMessage = '连接服务器失败'
      console.log(error,'error')

    }


    if (error.message.indexOf('400') !== -1) {
      if (error && error.response) {
        Message({
          showClose: true,
          type: 'error',
          message: errorMessage
        })
      }
      return Promise.reject(error.response)
    }
    Message({
      showClose: true,
      type: 'error',
      message: errorMessage
    })
    return Promise.reject(error.response)
  }
)
const formateData = data => {
  return {
    head: {
      versionNum: "v1.2.1",
      versionType: "public",
    },
    body: {
      ...data
    }
  }
}
export default {
  get: (url, data = {}, responseType = '') => {
    return service({
      url: url,
      method: 'get',
      params: formateData(data),
      responseType: responseType
    })
  },
  post: (url, data = {}, responseType = '') => {
    return service({
      url: url,
      method: 'post',
      data: formateData(data),
      responseType: responseType
    })
  },
  postCom: (url, data = {}, responseType = "", config = {}) => {
    return service({
      url: url,
      method: "post",
      data: data,
      responseType: responseType,
      ...config
    });
  },
  getCom: (url, data = {}, responseType = "") => {
    return service({
      url: url,
      method: "get",
      params: data,
      responseType: responseType,
    });
  },

  postParams: (url, data = {}) => {
    return service({
      url: url,
      method: 'post',
      params: data
    })
  },
  patch: (url, data = {}) => {
    return service({
      url: url,
      method: 'patch',
      data: formateData(data)
    })
  },
  delete: (url, data = {}) => {
    return service({
      url: url,
      method: 'delete',
      data: formateData(data)
    })
  },
  put: (url, data = {}) => {
    return service({
      url: url,
      method: 'put',
      data: formateData(data)
    })
  }
}
